export const NoteDeleteConfirm = (props, context) => {
  const store = context.root.$store
  const close = () => {
    context.emit('closeNoteDeleteConfirm')
  }

  const action = () => {
    store
      .dispatch('note/deleteNote')
      .then(() => {
        store
          .dispatch('note/getTags')
          .then(() => {
            store.dispatch('note/reset')
            store.dispatch('note/getUserLists')
            store.dispatch('note/getNoteLists')
            store.dispatch('note/getNoteCount')
            store.dispatch('common/showToast', { text: 'ノートを削除しました' })
            context.emit('closeNoteDeleteConfirm')
          })
      })
  }

  return {
    close,
    action
  }
}
